module.exports = "/assets/0a6e09c3d32e2350085f05a57a264180.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/U6.png
// module id = 1880
// module chunks = 0